import { render, staticRenderFns } from "./workBenifitChart.vue?vue&type=template&id=b991a50c&scoped=true&"
import script from "./workBenifitChart.vue?vue&type=script&lang=js&"
export * from "./workBenifitChart.vue?vue&type=script&lang=js&"
import style0 from "./workBenifitChart.vue?vue&type=style&index=0&id=b991a50c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b991a50c",
  null
  
)

export default component.exports